import styled from 'styled-components'
import { height, HeightProps, width, WidthProps } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

// A logo lockup, not a page banner — <header> here was a landmark misuse.
export const Container = styled.div<WidthProps & HeightProps>`
  display: flex;
  align-items: center;
  gap: ${themeGet('space.4')}px;

  > svg:last-of-type {
    height: 32%;
  }

  > svg:first-of-type {
    height: 100%;
  }

  ${width}
  ${height}
`
